module.exports = __webpack_public_path__ + "img/copy-icon.0dbf1fbd.svg";